import React from 'react';
import { Link } from 'react-router-dom';

import { CgProfile } from "react-icons/cg";
import { GoHome } from "react-icons/go";
import { LuCalendarSearch } from "react-icons/lu";
import { TbLogout2 } from "react-icons/tb";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";

import { MenuContainer, LogoContainer, MenuLogo, MenuWrapper, MenuItem, Imgs } from '../styles';

const Sidebar = ({userRole}) => {
  return (
    <MenuContainer>
      <LogoContainer>
        <MenuLogo src={Imgs.logo} alt="Logo" />
      </LogoContainer>
      <MenuWrapper>
        <MenuItem>
          <Link to="/home"> 
            <GoHome size={30} />
            <span style={{ fontFamily: "Bellota", fontSize: "15px" }}>Início</span>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/home/profile"> 
            <CgProfile size={30} />
            <span style={{ fontFamily: "Bellota", fontSize: "15px" }}>Perfil</span>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/home/schedule"> 
            <LuCalendarSearch size={30} />
            <span style={{ fontFamily: "Bellota", fontSize: "15px" }}>Agendamento</span>
          </Link>
        </MenuItem>
        {userRole === 'admin' && (
          <MenuItem>
            <Link to="/home/admin">
              <GrUserAdmin size={30} />
              <span style={{ fontFamily: "Bellota", fontSize: "15px" }}>Administrador</span>
            </Link>
          </MenuItem>
        )}
        {userRole === 'worker' && (
          <MenuItem>
            <Link to="/home/worker">
              <GrUserWorker size={30} />
              <span style={{ fontFamily: "Bellota", fontSize: "15px" }}>Trabalhador</span>
            </Link>
          </MenuItem>
        )}
        <MenuItem>
          <Link to="/">
            <TbLogout2 size={30} />
            <span style={{ fontFamily: "Bellota", fontSize: "15px" }}>Sair</span>
          </Link>
        </MenuItem>
      </MenuWrapper>
    </MenuContainer>
  );
};

export default Sidebar;
